import React from "react";

const indicators = [
  { label: "Esprit critique", value: 88 },
  { label: "Curiosité", value: 93 },
  { label: "Logique", value: 81 },
  { label: "Attention", value: 76 },
];

export function HeroCognitivePreviewCard() {
  return (
    <div className="h-full w-full rounded-3xl bg-white shadow-xl border border-slate-100 p-6 lg:p-8 flex flex-col gap-6 dark:bg-slate-900 dark:border-slate-800">
      <header className="space-y-1">
        <p className="text-xs font-semibold tracking-[0.16em] uppercase text-sky-500">Aperçu MixMind</p>
        <p className="mt-1 text-sm font-medium text-slate-900 dark:text-slate-100">
          Un exemple de tableau de bord cognitif généré avec l’intelligence mixte.
        </p>
      </header>

      <div className="mt-2 rounded-2xl bg-gradient-to-br from-sky-50 via-indigo-50 to-slate-50 dark:from-slate-800 dark:via-slate-900 dark:to-slate-950 p-4 flex flex-col gap-3">
        <div className="h-3 w-32 rounded-full bg-sky-200/80 dark:bg-sky-700/60" />
        <div className="h-2 w-48 rounded-full bg-slate-200/80 dark:bg-slate-700/60" />
        <div className="h-2 w-40 rounded-full bg-slate-200/60 dark:bg-slate-700/40" />
        <div className="mt-3 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 rounded-2xl bg-white/80 dark:bg-slate-900/80 px-4 py-3 shadow-sm border border-slate-100/80 dark:border-slate-800/80">
          <div>
            <p className="text-xs font-semibold text-slate-500 dark:text-slate-400">Profil cognitif mixte</p>
            <p className="text-sm font-medium text-slate-900 dark:text-slate-100">Élève 11–15 ans · Mode classe</p>
          </div>
          <div className="flex items-center gap-2">
            <span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-sky-500 text-xs font-semibold text-white">
              IA
            </span>
            <span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-emerald-500 text-xs font-semibold text-white">
              Toi
            </span>
          </div>
        </div>
      </div>

      <div>
        <div className="flex items-center justify-between mt-2">
          <p className="text-xs font-semibold text-slate-500 dark:text-slate-400">Indicateurs illustratifs (exemple)</p>
          <p className="text-[11px] text-slate-400 dark:text-slate-500">Données fictives · Démo</p>
        </div>

        <div className="mt-3 space-y-2.5">
          {indicators.map((indicator) => (
            <div key={indicator.label} className="space-y-1">
              <div className="flex items-center justify-between text-xs">
                <span className="font-medium text-slate-700 dark:text-slate-200">{indicator.label}</span>
                <span className="text-slate-400 dark:text-slate-500">
                  {indicator.value}
                  <span className="text-[10px]"> /100</span>
                </span>
              </div>
              <div className="h-1.5 w-full rounded-full bg-slate-100 dark:bg-slate-800 overflow-hidden">
                <div
                  className="h-full rounded-full bg-gradient-to-r from-sky-500 to-emerald-500 transition-all duration-700 ease-out"
                  style={{ width: `${indicator.value}%` }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>

      <p className="mt-3 text-[11px] leading-snug text-slate-400 dark:text-slate-500">
        Exemple d’interface MixMind pour illustrer la collaboration entre l’IA et l’humain. Cet aperçu est purement
        démonstratif.
      </p>
    </div>
  );
}
